import React from "react";
import { motion } from "framer-motion";
import { LEADERSHIP } from "@/constants/testIds";

const LEADERS = [
  {
    key: "hemanth",
    name: "Hemanth Kumar S",
    role: "Founder · Business Development Director · Lead Solutions Architect",
    tenure: "3 yrs",
    img: "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/83cew1re_image.png",
    bio: "Sets the vision. Owns strategic client relationships and end-to-end delivery architecture.",
  },
  {
    key: "chethan",
    name: "Chethan",
    role: "COO · HR · Lead Technical Architect",
    tenure: "3 yrs banking IT",
    img: "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/2kvqpqy6_image.png",
    bio: "Operational spine of the company. Deep banking-IT background powers our enterprise reliability.",
  },
  {
    key: "raksha",
    name: "Raksha",
    role: "Chief Financial Officer",
    tenure: "5 yrs",
    img: "https://customer-assets-rejwkqb3.emergentagent.net/job_hr-enterprises/artifacts/d8p7zn9b_image.png",
    bio: "Governs financial health, unit economics and pricing across all AURIX divisions.",
  },
  {
    key: "raja",
    name: "Raja Srinivas",
    role: "CCO · Lead Web Architect · AI Content Strategist",
    tenure: "4.5 yrs",
    img: "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/j3ttiokq_image.png",
    bio: "Client experience + web architecture + AI-driven content — the trident behind every AURIX build.",
  },
  {
    key: "darshan",
    name: "Darshan",
    role: "Head of Sales & Operations (B2B & B2C)",
    tenure: "3 yrs",
    img: "https://customer-assets.emergentagent.com/job_hr-enterprises/artifacts/s2l7z8di_image.png",
    bio: "Runs the revenue engine. Builds pipelines and closes strategic accounts across sectors.",
  },
];

const Leadership = () => {
  return (
    <section
      id="leadership"
      data-testid={LEADERSHIP.root}
      className="relative py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-14 flex flex-col items-start justify-between gap-6 lg:mb-20 lg:flex-row lg:items-end">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <div className="h-px w-8 bg-[var(--gold)]/60" />
              <span className="font-mono-label text-[var(--gold)]">
                03 · Meet The Builders
              </span>
            </div>
            <h2 className="font-display text-4xl leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Meet the<br />
              <span className="silver-gradient-text">builders.</span>
            </h2>
          </div>
          <p className="max-w-md text-[15px] leading-relaxed text-zinc-400">
            Five minds. One mission. Creating businesses built for tomorrow.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {LEADERS.map((l, idx) => (
            <motion.article
              key={l.key}
              data-testid={`${LEADERSHIP.cardPrefix}-${l.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: idx * 0.08,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0e0e10]"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={l.img}
                  alt={l.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] group-hover:scale-[1.05]"
                  style={{ filter: "contrast(1.05) saturate(0.95)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#08080a] via-[#08080a]/40 to-transparent" />
                <div className="absolute left-4 top-4 rounded-full border border-white/15 bg-black/40 px-2.5 py-1 backdrop-blur">
                  <span className="font-mono-label text-[10px] text-zinc-300">
                    {l.tenure}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-display text-[17px] font-semibold tracking-tight text-white">
                  {l.name}
                </h3>
                <p className="mt-1 text-[12px] leading-relaxed text-[var(--gold-bright)]/85">
                  {l.role}
                </p>
                <p className="mt-3 text-[13px] leading-relaxed text-zinc-400">
                  {l.bio}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
